import { render } from "./OrderStore.vue?vue&type=template&id=0f1f9c41"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/OrderStore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f1f9c41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f1f9c41', __exports__)) {
    api.reload('0f1f9c41', __exports__)
  }
  
  module.hot.accept("./OrderStore.vue?vue&type=template&id=0f1f9c41", () => {
    api.rerender('0f1f9c41', render)
  })

}


export default __exports__